import { useState } from "react";
import { LocateFixed, MapPin } from "lucide-react";
import { toast } from "sonner";
import { formatErr } from "@/lib/api";
import { browserLocation, geocode, useMapsEnabled, usePlaceLabel } from "@/lib/geo";

export function NearBox({ f, setLoc }) {
  const maps = useMapsEnabled();
  const label = usePlaceLabel(f.lat, f.lng, maps);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const locate = () => browserLocation().then(setLoc).catch((e) => toast.error(e.message));
  const find = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const p = await geocode(q); setLoc({ lat: p.lat, lng: p.lng }); setQ(""); } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  if (f.sort !== "nearest") return null;
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2 text-xs" data-testid="near-box">
      {f.lat ? <span className="asv-chip inline-flex items-center gap-1" data-testid="near-label"><MapPin className="h-3 w-3" />Nearest to {label || "your location"}</span>
        : <span className="asv-muted" data-testid="near-hint">Share your location{maps ? " or enter your area" : ", or pick a city in the filters,"} to sort by distance.</span>}
      <button type="button" onClick={locate} className="asv-btn-ghost !py-1.5 !text-xs" data-testid="near-use-location"><LocateFixed className="h-3.5 w-3.5" />Use my location</button>
      {maps && <form onSubmit={find} className="flex gap-2">
        <input className="asv-input !h-9 !w-48 !text-xs" placeholder="Area, city or postcode" value={q} onChange={(e) => setQ(e.target.value)} minLength={2} required data-testid="near-place-input" />
        <button className="asv-btn !py-1.5 !text-xs" disabled={busy} data-testid="near-place-submit">Go</button>
      </form>}
    </div>
  );
}
